module.exports = __webpack_public_path__ + "img/down-chevron.b9a110df.svg";